export default {

    sendLogAccess: {
        url: 'log/save',
        method: 'post',
    },
    sendLogAccessWithoutToken: {
        url: 'auth/log/save',
        method: 'post',
    },

    getDebtsClaro: {
        url: 'claro/debts',
        method: 'get',
    },
    
    getOffersClaro: {
        url: 'claro/getOffers',
        method: 'post',
    },
    
    getAgreementClaro: {
        url: 'claro/agreement',
        method: 'post',
    },
    
    sendSmsOrEmail: { 
        url: 'sendOffer', 
        method: 'post', 
    },

    downloadBill: { 
        url: 'claro/boleto', 
        method: 'post', 
    },

    insertValuesContract: { 
        url: 'claro/insertValuesContract', 
        method: 'post', 
    },

    getValuesContract: { 
        url: 'claro/getValuesContract', 
        method: 'post', 
    },

    deleteValuesContract: { 
        url: 'claro/deleteValuesContract', 
        method: 'post', 
    },

    getInstallmentsClaro: { 
        url: 'claro/getInstallments', 
        method: 'get', 
    },

    insertLogByValueId: { 
        url: 'claro/insertLog', 
        method: 'post', 
    },

    getDebtsPortoSeguro: {
        url: 'porto/debts',
        method: 'post',
    },

    emitirFaturaPortoSeguro: {
        url: 'porto/emitirFatura',
        method: 'post',
    },

    boletoPortoSeguro: {
        url: 'porto/boleto',
        method: 'post',
    },

    boletosLinhaDigitavelPortoSeguro: {
        url: 'porto/boletoLinhaDigitavel',
        method: 'post',
    },

    boletoInfoPortoSeguro: {
        url: 'porto/boletoInfo',
        method: 'post',
    },

    pixPortoSeguro: {
        url: 'porto/pix',
        method: 'post',
    },

    getOffersPortoSeguro: {
        url: 'porto/offers',
        method: 'post',
    },

    getOffersFaturaPortoSeguro: {
        url: 'porto/offersFatura',
        method: 'post',
    },

    agreementPortoSeguro: {
        url: 'porto/agreement',
        method: 'post',
    },
    
    sendMessagePortoSeguro: {
        url: 'porto/send-message',
        method: 'post',
    },

    historyMessagesPortoSeguro: {
        url: 'porto/history',
        method: 'post',
    },

    clickAvatar: {
        url: 'clickAvatar',
        method: 'post',
    },
    

}